import React, { useCallback, useEffect, useState } from 'react'
import styles from "./Templateadmin.module.css"
import CustomModal from '../Dashboardcomponents/Modal'
import { useDropzone } from 'react-dropzone';
import { getTemplatesByCategory, uploadTemplate } from '../../dashboardapi';
import { ChakraProvider, useToast } from '@chakra-ui/react';
import Custheme from '../ChakraCustom';

const Templateadmin = () => {
    const [openModal, setOpenModal] = useState(false);
    const [editingTemplate, setEditingTemplate] = useState(null); // null means Add, object means Edit
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const toast = useToast()
    const [category, setCategory] = useState("journal_articles")
    const [data, setData] = useState([])

    const [formValues, setFormValues] = useState({
        Name: "",
        Category: "",
        Status: "",
        Description: "",
        Price: "",
        Tags: "",
        Images: [],       // For image files
        Files: []         // New input for other files
    });

    const template = [
        { Images: [], Name: "", Category: "", Downloads: "", Status: "" },
        { Images: [], Name: "", Category: "", Downloads: "", Status: "" },
        { Images: [], Name: "", Category: "", Downloads: "", Status: "" }
    ];

    const onDropImages = useCallback((acceptedFiles) => {
        setFormValues(prev => ({ ...prev, Images: [...prev.Images, ...acceptedFiles] }));
    }, []);

    const onDropFiles = useCallback((acceptedFiles) => {
        setFormValues(prev => ({ ...prev, Files: [...prev.Files, ...acceptedFiles] }));
    }, []);

    const { getRootProps: getRootPropsImages, getInputProps: getInputPropsImages } = useDropzone({
        onDrop: onDropImages,
        accept: { 'image/*': [] },
        multiple: true
    });

    const { getRootProps: getRootPropsFiles, getInputProps: getInputPropsFiles } = useDropzone({
        onDrop: onDropFiles,
        multiple: true
    });

    // Prefill form when editing
    const handleEditTemplate = (item) => {
        console.log(item);

        setEditingTemplate(item);
        setFormValues({
            Name: item.name || "",
            // Category: item.Category.toLowerCase() || "",
            Status: item.status || "",
            Description: item.description || "",
            Tags: item.tags || "",
            Images: item.previews || [],
            Files: item.files || []
        });
        setOpenModal(true);
    };

    const handleAddTemplate = () => {
        setEditingTemplate(null);
        setFormValues({
            Name: "",
            Category: "",
            Status: "",
            Description: "",
            Price: "",
            Tags: "",
            Images: [],       // For image files
            Files: []
        });
        setOpenModal(true);
    };

    const handleInputChange = (e) => {
        const { name, value, files } = e.target;
        if (files) {
            setFormValues(prev => ({ ...prev, [name]: Array.from(files) }));
        } else {
            setFormValues(prev => ({ ...prev, [name]: value }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        // Create FormData object
        const formData = new FormData();

        // Append text fields
        formData.append("name", formValues.Name);
        formData.append("category", formValues.Category);
        formData.append("status", formValues.Status);
        formData.append("description", formValues.Description);
        formData.append("tags", formValues.Tags);

        // Convert Images array to a single array in FormData
        if (formValues.Images.length > 0) {
            formValues.Images.forEach(file => formData.append("images", file));
        }

        // Convert Files array to a single array in FormData
        if (formValues.Files.length > 0) {
            formValues.Files.forEach(file => formData.append("files", file));
        }
        console.log(formData)
        try {
            uploadTemplate(formData).then((res) => {
                if (res.data) {
                    toast({
                        title: "Template created successfully...",
                        description: res.data.data,
                        status: "success",
                        duration: 2000,
                        isClosable: "true"
                    })
                    setOpenModal(false)
                } else {
                    toast({
                        title: "Please enter valid search",
                        description: res.error.error,
                        status: "error",
                        duration: 2000,
                        isClosable: "true"
                    })
                }
            })
            // setOpenModal(false);
        } catch (err) {
            console.error("Error submitting template:", err);
        }
    };


    const handleDelete = (item) => {
        setShowDeleteModal(true)
    }

    const retriveCategory = async () => {
        const catdetail = await getTemplatesByCategory(category);
        if (catdetail.data) {
            setData(catdetail.data.data)
        } else {
            console.log("No data to show");
        }
    }

    useEffect(() => {
        retriveCategory();
    }, [category])

    console.log(data);

    //MARK:AdminTemplates
    return (
        <main className={styles.main}>
            <div className={styles.container}>
                <div className={styles.admin_header}>
                    <p style={{ fontWeight: "500" }} className={styles.titles}>Templates</p>
                    <button className={`${styles.btn} ${styles.btn_black}`} onClick={handleAddTemplate}>
                        + Add New Template
                    </button>
                </div>

                <div className={styles.categoryselect}>
                    <p>Select Category</p>
                    <select value={category} onChange={(e) => setCategory(e.target.value)} style={{ padding: "2px 10px", background: "var(--bg)", border: "1px solid var(--border)", outline: "none", borderRadius: "6px" }}>
                        <option value="">Select Category</option>
                        <option value="journal_articles">Journal articles</option>
                        <option value="books">Books</option>
                        <option value="calendars">Calendars</option>
                        <option value="formal_letters">Formal letters</option>
                        <option value="assignments">Assignments</option>
                        <option value="presentations">Presentations</option>
                        <option value="reports">Reports</option>
                    </select>
                </div>

                <div className={styles.admin_table_container}>
                    <table className={styles.admin_table}>
                        <thead>
                            <tr>
                                {Object.keys(template[0]).map((key, i) => <th key={i}>{key}</th>)}
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody id="templatesTableBody">
                            {data.length > 0 ? data.map((item, i) => (
                                <tr key={i} style={{ maxHeight: "100px" }}>
                                    <td> <img
                                        style={{ height: "auto", maxHeight: "100px", width: "auto", }}
                                        src={`data:image/jpeg;base64,${item?.previews[0]}`}
                                        alt={`img ${1}`}
                                    /></td>
                                    <td>
                                        {item.name}
                                    </td>
                                    <td>{category}</td>
                                    <td> ---- </td>
                                    <td>Active</td>
                                    <td>
                                        <button
                                            className={`${styles.btn_icon} ${styles.edit}`}
                                            onClick={() => handleEditTemplate(item)}
                                            title="Edit"
                                        >
                                            ✏️
                                        </button>
                                        <button
                                            className={`${styles.btn_icon} ${styles.delete}`}
                                            onClick={() => handleDelete(item)}
                                            title="Delete"
                                        >
                                            🗑️
                                        </button>
                                    </td>
                                </tr>
                            )) : <tr >No templates available</tr>}
                        </tbody>
                    </table>
                </div>

                {/* Modal for Add/Edit */}
                {openModal && (
                    <CustomModal show={openModal}>
                        <div className={styles.modal_content}>
                            <div className={styles.modal_header}>
                                <h2 id="modalTitle">{editingTemplate ? "Edit Template" : "Add New Template"}</h2>
                                <button className={styles.modal_close} onClick={() => setOpenModal(false)}>&times;</button>
                            </div>
                            <form id="templateForm" className={styles.modal_form} onSubmit={handleSubmit}>
                                <div className={styles.form_row}>
                                    <div className={styles.form_group}>
                                        <label htmlFor="Name">Template Name</label>
                                        <input type="text" id="Name" name="Name" required value={formValues.Name} onChange={handleInputChange} />
                                    </div>
                                    <div className={styles.form_group}>
                                        <label htmlFor="Category">Category</label>
                                        <select id="Category" name="Category" required value={formValues.Category} onChange={handleInputChange}>
                                            <option value="">Select Category</option>
                                            <option value="journal_articles">Journal articles</option>
                                            <option value="books">Books</option>
                                            <option value="calendars">Calendars</option>
                                            <option value="formal_letters">Formal letters</option>
                                            <option value="assignments">Assignments</option>
                                            <option value="presentations">Presentations</option>
                                            <option value="reports">Reports</option>
                                        </select>
                                    </div>
                                </div>

                                <div className={styles.form_row}>
                                    <div className={styles.form_group}>
                                        <label htmlFor="Images">Template Image</label>
                                        <div {...getRootPropsImages()} className={styles.dropzone}>
                                            <input {...getInputPropsImages()} />
                                            <p>Drag & drop images here, or click to select files</p>
                                        </div>
                                        <div className={styles.preview}>
                                            {formValues.Images.slice(0, 4).map((item, i) => {
                                                // Check if item is a File object or Base64 string
                                                const src = item instanceof File
                                                    ? URL.createObjectURL(item)          // local file
                                                    : `data:image/jpeg;base64,${item}`; // base64 from API

                                                const altText = item instanceof File ? item.name : `image-${i}`;

                                                return (
                                                    <div key={i} className={styles.thumb}>
                                                        <img src={src} alt={altText} />
                                                    </div>
                                                );
                                            })}

                                            {formValues.Images.length > 4 && (
                                                <div className={styles.moreFiles}>
                                                    +{formValues.Images.length - 4} more
                                                </div>
                                            )}
                                        </div>

                                    </div>

                                    <div className={styles.form_group}>
                                        <label htmlFor="Files">Template Files</label>
                                        <div {...getRootPropsFiles()} className={styles.dropzone}>
                                            <input {...getInputPropsFiles()} />
                                            <p>Drag & drop files here, or click to select files</p>
                                        </div>
                                        <div className={styles.preview}>
                                            {formValues.Files.slice(0, 4).map((file, i) => {
                                                // Determine the display name
                                                const name = file instanceof File
                                                    ? file.name                      // local uploaded file
                                                    : file || `file-${i}`;      // API-provided file (fallback if name missing)

                                                return (
                                                    <div key={i} className={styles.fileThumb}>
                                                        <div className={styles.fileIcon}>📄</div>
                                                        <span className={styles.fileName}>
                                                            {name.length > 10 ? name.slice(0, 10) + "..." : name}
                                                        </span>
                                                    </div>
                                                );
                                            })}

                                            {formValues.Files.length > 4 && (
                                                <div className={styles.moreFiles}>
                                                    +{formValues.Files.length - 4} more
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                    <div className={styles.form_group}>
                                        <label htmlFor="Status">Status</label>
                                        <select id="Status" name="Status" required value={formValues.Status} onChange={handleInputChange}>
                                            <option value="active">Active</option>
                                            <option value="draft">Draft</option>
                                            <option value="archived">Archived</option>
                                        </select>
                                    </div>
                                    <div className={styles.form_group}>
                                        <label htmlFor="Tags">Tags (comma separated)</label>
                                        <input type="text" id="Tags" name="Tags" placeholder="responsive, modern, clean" value={formValues.Tags} onChange={handleInputChange} />
                                    </div>
                                </div>

                                <div className={styles.form_group}>
                                    <label htmlFor="Description">Description</label>
                                    <textarea id="Description" name="Description" rows="4" placeholder="Template description..." value={formValues.Description} onChange={handleInputChange}></textarea>
                                </div>

                                <div className={styles.form_row}>

                                </div>

                                <div className={styles.form_actions}>
                                    <button type="button" className={`${styles.btn} ${styles.btn_secondary}`} onClick={() => setOpenModal(false)}>Cancel</button>
                                    <ChakraProvider theme={Custheme}>
                                        <button type="submit" className={`${styles.btn} ${styles.btn_black}`}>Save Template</button>
                                    </ChakraProvider>
                                </div>
                            </form>
                        </div>
                    </CustomModal>
                )}

                {
                    showDeleteModal &&
                    <CustomModal show={showDeleteModal}>
                        <div class={`${styles.modal_content}`}>
                            <div class={styles.modal_header}>
                                <h2>Confirm Delete</h2>
                                <button class={styles.modal_close} onClick={() => setShowDeleteModal(false)}>&times;</button>
                            </div>
                            <div class={styles.modal_body}>
                                <p>Are you sure you want to delete this template? This action cannot be undone.</p>
                            </div>
                            <div class={styles.form_actions} style={{ padding: "10px" }}>
                                <button type="button" class={`${styles.btn} ${styles.btn_secondary}`} onClick={() => setShowDeleteModal(false)}>Cancel</button>
                                <button type="button" class={`${styles.btn} ${styles.btn_danger}`} onclick="confirmDelete()">Delete</button>
                            </div>
                        </div>
                    </CustomModal>
                }
            </div>
        </main>
    );
};

export default Templateadmin;